import { useParams, useLocation, matchPath, generatePath } from 'react-router-dom';
import ROUTES_PATH from 'domain/router/routesPathConfig';

const useRedirectBetweenApps = () => {
  const { companyId } = useParams();
  const location = useLocation();
  const path = location.pathname;
  const getRedirectUrl = () => {
    // from AP to PAY
    if (
      matchPath(
        {
          path: ROUTES_PATH.COMPANY_WORKSPACE.absolute,
        },
        path,
      ) ||
      matchPath(
        {
          path: ROUTES_PATH.COMPANY_CONFIDENTIAL_WORKSPACE.absolute,
        },
        path,
      )
    ) {
      return generatePath(ROUTES_PATH.PAY_COMPANY.absolute, { companyId });
    }

    if (
      matchPath(
        {
          path: ROUTES_PATH.DOCUMENT.absolute,
        },
        path,
      )
    ) {
      return generatePath(ROUTES_PATH.PAY_COMPANY.absolute, { companyId });
    }

    if (
      matchPath(
        {
          path: ROUTES_PATH.COMPANY_SETTINGS.absolute,
        },
        path,
      )
    ) {
      return generatePath(ROUTES_PATH.PAY_COMPANY_SETTINGS_PROVIDERS.absolute, { companyId });
    }

    // from PAY to AP
    if (
      matchPath(
        {
          path: ROUTES_PATH.PAY_COMPANY.absolute,
          end: false,
        },
        path,
      )
    ) {
      return generatePath(ROUTES_PATH.COMPANY_WORKSPACE_CATEGORY_UNDEFINED.absolute, { companyId });
    }

    if (
      matchPath(
        {
          path: ROUTES_PATH.PAY_PAYMENT.absolute,
        },
        path,
      )
    ) {
      return generatePath(ROUTES_PATH.COMPANY_WORKSPACE_CATEGORY_UNDEFINED.absolute, { companyId });
    }

    if (
      matchPath(
        {
          path: ROUTES_PATH.PAY_COMPANY_SETTINGS.absolute,
        },
        path,
      )
    ) {
      return generatePath(ROUTES_PATH.COMPANY_SETTINGS_GENERAL_MAIN.absolute, { companyId });
    }

    return null;
  };

  const redirectBetweenApps = () => {
    const newUrl = getRedirectUrl(location.pathname);
    if (newUrl) {
      window.open(newUrl, '_blank');
    }
  };

  return { redirectBetweenApps, isPayModule: path.startsWith('/pay/') };
};

export default useRedirectBetweenApps;
